import { render, staticRenderFns } from "./ProtectedRouteAndNotFoundGuard.vue?vue&type=template&id=63b8dd2c&"
import script from "./ProtectedRouteAndNotFoundGuard.vue?vue&type=script&lang=js&"
export * from "./ProtectedRouteAndNotFoundGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b8dd2c')) {
      api.createRecord('63b8dd2c', component.options)
    } else {
      api.reload('63b8dd2c', component.options)
    }
    module.hot.accept("./ProtectedRouteAndNotFoundGuard.vue?vue&type=template&id=63b8dd2c&", function () {
      api.rerender('63b8dd2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProtectedRouteAndNotFoundGuard.vue"
export default component.exports